import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, ArrowLeft } from "lucide-react";
import { api, inr } from "@/lib/api";

const Row = ({ k, v, id }) => (
  <div className="flex justify-between gap-4 py-3 border-b border-dashed border-black/20">
    <span className="font-mono text-xs uppercase tracking-[0.2em] text-black/60">{k}</span>
    <span className="font-semibold text-right" data-testid={id}>{v}</span>
  </div>
);

export default function BookingSuccess() {
  const [params] = useSearchParams();
  const code = params.get("code");
  const [b, setB] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    if (!code) { setErr(true); return; }
    api.get(`/bookings/${code}`).then((r) => setB(r.data)).catch(() => setErr(true));
  }, [code]);

  return (
    <main data-testid="booking-success-page" className="min-h-screen flex items-center justify-center px-5 py-16">
      <div className="w-full max-w-lg">
        <Link to="/" data-testid="success-back-home" className="inline-flex items-center gap-2 text-sm text-slate-300 hover:text-[#FFEF00] mb-8"><ArrowLeft size={16} /> Back to ZoopUp</Link>
        {err && <p data-testid="success-error" className="text-slate-300">We couldn't find that booking. Please check your code.</p>}
        {b && (
          <motion.div initial={{ opacity: 0, y: 40, rotate: -2 }} animate={{ opacity: 1, y: 0, rotate: 0 }} transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="rounded-[30px] bg-[#FFEF00] text-black border-[3px] border-black shadow-[10px_10px_0_#14C3F7] p-7 md:p-9">
            <div className="flex items-center justify-between">
              <img src="/brand/logo.png" alt="ZoopUp" className="h-10 w-auto" />
              <CheckCircle2 size={30} />
            </div>
            <p className="mt-8 font-mono text-xs uppercase tracking-[0.25em]">Booking confirmed</p>
            <p className="font-display font-black text-4xl md:text-5xl mt-1" data-testid="success-booking-code">{b.code}</p>
            <div className="mt-6">
              <Row k="Item" v={b.title} id="success-title" />
              <Row k="Location" v={b.location} id="success-location" />
              {b.date && <Row k="When" v={`${b.date} · ${b.slot}`} id="success-when" />}
              {b.kind === "package" && <Row k="Guests" v={b.guests} id="success-guests" />}
              {b.bonus > 0 && <Row k="Bonus" v={inr(b.bonus)} id="success-bonus" />}
              <Row k="Amount" v={inr(b.total)} id="success-total" />
              <Row k="Payment" v="Pay at venue" id="success-payment" />
            </div>
            <p className="mt-6 text-sm text-black/75">Show this code at the ZoopUp counter. Screenshot it so you have it handy.</p>
          </motion.div>
        )}
      </div>
    </main>
  );
}
